import DefaultLayout from "@/layouts/DefaultLayout";
import SpecSheetDeleteDialog from "kinnect-front/CounterSales/SpecSheets/SpecSheetDeleteDialog";
import SpecSheetForm from "kinnect-front/CounterSales/SpecSheets/SpecSheetForm";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { SpecSheet } from "kinnect-models";

export default {
	name: "SpecSheetPage",

	metaInfo() {
		const title = this.editing
			? "View Spec Sheet"
			: "Add Spec Sheet";

		return { title };
	},

	props: { idSpecSheet: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "spec_sheets",
		deleteDialogOpen: false,
		specSheet: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idSpecSheet );
		},

		genDeleteDialog() {
			if ( this.editing && this.specSheet && this.canDelete ) {
				return <SpecSheetDeleteDialog
					item={this.specSheet}
					onConfirm={() => this.specSheet.delete()}
					redirect={[ "back", { name: "specSheets" } ]}
					vModel={this.deleteDialogOpen}
				></SpecSheetDeleteDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete",
					tooltip: "Delete this spec sheet"
				};
			}
		}
	},

	methods: {
		async fetchSpecSheet() {
			if ( this.editing ) {
				this.specSheet = await SpecSheet
				.include( [ "statuses" ] )
				.findPageModel( this.idSpecSheet );
			}
		},

		async fetch() {
			await this.fetchSpecSheet();
		}
	},

	render() {
		return <DefaultLayout>
			<SpecSheetForm
				loading={this.$wait.is( "find spec sheet" )}
				readonly={this.editing ? !this.canEdit : false}
				specSheet={this.specSheet}
			></SpecSheetForm>

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
